import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _acdded06 = () => interopDefault(import('../src/pages/cookie-policy.vue' /* webpackChunkName: "pages/cookie-policy" */))
const _6e60a655 = () => interopDefault(import('../src/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _5c1ccee2 = () => interopDefault(import('../src/pages/manage-booking/index.vue' /* webpackChunkName: "pages/manage-booking/index" */))
const _727bc7c5 = () => interopDefault(import('../src/pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _2b3ca00c = () => interopDefault(import('../src/pages/receipt.vue' /* webpackChunkName: "pages/receipt" */))
const _5e09e054 = () => interopDefault(import('../src/pages/search.vue' /* webpackChunkName: "pages/search" */))
const _38c22c65 = () => interopDefault(import('../src/pages/search-booking/index.vue' /* webpackChunkName: "pages/search-booking/index" */))
const _be3cd1bc = () => interopDefault(import('../src/pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _82ee2090 = () => interopDefault(import('../src/pages/travel-extras.vue' /* webpackChunkName: "pages/travel-extras" */))
const _1e328e52 = () => interopDefault(import('../src/pages/unsupported-browser.vue' /* webpackChunkName: "pages/unsupported-browser" */))
const _463abcc6 = () => interopDefault(import('../src/pages/manage-booking/cancel/index.vue' /* webpackChunkName: "pages/manage-booking/cancel/index" */))
const _45c920da = () => interopDefault(import('../src/pages/manage-booking/modify.vue' /* webpackChunkName: "pages/manage-booking/modify" */))
const _303bb748 = () => interopDefault(import('../src/pages/manage-booking/receipt.vue' /* webpackChunkName: "pages/manage-booking/receipt" */))
const _544df35e = () => interopDefault(import('../src/pages/manage-booking/update-details.vue' /* webpackChunkName: "pages/manage-booking/update-details" */))
const _7b0c2a79 = () => interopDefault(import('../src/pages/select-extras/product/index.vue' /* webpackChunkName: "pages/select-extras/product/index" */))
const _d250717a = () => interopDefault(import('../src/pages/manage-booking/cancel/receipt.vue' /* webpackChunkName: "pages/manage-booking/cancel/receipt" */))
const _2f2567d8 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cookie-policy",
    component: _acdded06,
    name: "cookie-policy"
  }, {
    path: "/maintenance",
    component: _6e60a655,
    name: "maintenance"
  }, {
    path: "/manage-booking",
    component: _5c1ccee2,
    name: "manage-booking"
  }, {
    path: "/privacy-policy",
    component: _727bc7c5,
    name: "privacy-policy"
  }, {
    path: "/receipt",
    component: _2b3ca00c,
    name: "receipt"
  }, {
    path: "/search",
    component: _5e09e054,
    name: "search"
  }, {
    path: "/search-booking",
    component: _38c22c65,
    name: "search-booking"
  }, {
    path: "/terms-and-conditions",
    component: _be3cd1bc,
    name: "terms-and-conditions"
  }, {
    path: "/travel-extras",
    component: _82ee2090,
    name: "travel-extras"
  }, {
    path: "/unsupported-browser",
    component: _1e328e52,
    name: "unsupported-browser"
  }, {
    path: "/manage-booking/cancel",
    component: _463abcc6,
    name: "manage-booking-cancel"
  }, {
    path: "/manage-booking/modify",
    component: _45c920da,
    name: "manage-booking-modify"
  }, {
    path: "/manage-booking/receipt",
    component: _303bb748,
    name: "manage-booking-receipt"
  }, {
    path: "/manage-booking/update-details",
    component: _544df35e,
    name: "manage-booking-update-details"
  }, {
    path: "/select-extras/product",
    component: _7b0c2a79,
    name: "select-extras-product"
  }, {
    path: "/manage-booking/cancel/receipt",
    component: _d250717a,
    name: "manage-booking-cancel-receipt"
  }, {
    path: "/",
    component: _2f2567d8,
    name: "index"
  }, {
    path: "/dedicated",
    component: _2f2567d8,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-index"
  }, {
    path: "/dedicated/search",
    component: _5e09e054,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-search"
  }, {
    path: "/dedicated/select-extras/product",
    component: _7b0c2a79,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-select-extras"
  }, {
    path: "/dedicated/travel-extras",
    component: _82ee2090,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-travel-extras"
  }, {
    path: "/dedicated/manage-booking/modify",
    component: _45c920da,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-modify"
  }, {
    path: "/dedicated/receipt",
    component: _2b3ca00c,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-receipt"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
